<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
 *{margin: 0px;padding:0px;}
 #app{
  height: 100%;
 }
 html,body{
  height: 100%;
  min-width: 1400px;
 }
 a{
    text-decoration: none;
  }
  .date_box{
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue